import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import noop from 'utils/noop';
import { createContext, useContext } from 'react';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { PAGE_SIZES } from 'ui/paginationFooter';
import { CriteriaTableColumn, CriteriaTableTab } from '../types';

type CriteriaIndexQueryContextState = {
  stateFilterTab: CriteriaTableTab;
  setStateFilterTab: (newTab: CriteriaTableTab) => void;
  searchTextInput: string;
  searchTextQuery: string;
  setSearchText: (search: string) => void;
  sortedBy: CriteriaTableColumn | undefined;
  pageNum: number;
  pageSize: number;
  setSortedBy: (sortBy: CriteriaTableColumn) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (direction: SORT_DIRECTIONS) => void;
  criterias: AnonUserCriteria[];
  criteriasLoading: boolean;
  totalCriteriaCount: number;
  refetchCriterias: () => void;
  maxActiveCriteriaLimitReached: boolean;
  setPageNum: (pageNum: number) => void;
  setPageSize: (pageSize: number) => void;
};

export const DEFAULT_INDEX_QUERY_CONTEXT_STATE: CriteriaIndexQueryContextState = {
  stateFilterTab: CriteriaTableTab.ALL,
  setStateFilterTab: noop,
  searchTextInput: '',
  searchTextQuery: '',
  setSearchText: noop,
  sortedBy: CriteriaTableColumn.ANONYMOUS_CRITERIA,
  pageNum: 1,
  pageSize: PAGE_SIZES[0],
  setSortedBy: noop,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
  setSortDirection: noop,
  criterias: [],
  criteriasLoading: false,
  totalCriteriaCount: 0,
  refetchCriterias: noop,
  maxActiveCriteriaLimitReached: false,
  setPageNum: noop,
  setPageSize: noop,
};

export const CriteriaIndexQueryContext = createContext<CriteriaIndexQueryContextState>(
  DEFAULT_INDEX_QUERY_CONTEXT_STATE,
);

export const useCriteriaIndexQueryContext = () => useContext(CriteriaIndexQueryContext);
